import React from 'react';
import {
  Box, HStack, Text, Tooltip, useToast,
} from '@chakra-ui/react';
import { FiCopy } from 'react-icons/fi';

// item 731 (Chad) — a copyable Stripe id shown right in the ledgers (subscription id /
// payment-intent / invoice id), so the reference you need to find a transaction or fight a
// dispute in Stripe is one click away without opening a modal. Mirrors the item-586
// deposits-ledger copy affordance.
const StripeIdChip: React.FC<{ id?: string | null; label?: string; iconOnly?: boolean }> = ({ id, label, iconOnly }) => {
  const toast = useToast();
  if (!id) return null;

  const short = id.length > 16 ? `${id.slice(0, 11)}…${id.slice(-4)}` : id;
  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation(); // ledgers make the row clickable — don't trigger the row action
    try {
      await navigator.clipboard.writeText(id);
      toast({ status: 'success', title: 'Copied', description: `${label ?? 'Stripe id'} copied to the clipboard.` });
    } catch {
      toast({ status: 'error', title: 'Copy failed', description: 'Could not copy to the clipboard.' });
    }
  };

  return (
    <Tooltip label={`${label ? `${label}: ` : ''}${id} — click to copy`} openDelay={300}>
      <Box as="button" type="button" onClick={copy} _hover={{ color: 'brand.100' }} color="gray.500" textAlign="left">
        {/* item 737 (Chad) — iconOnly keeps ledgers clean: just a copy glyph, full id in the tooltip */}
        {iconOnly ? (
          <FiCopy size={12} />
        ) : (
          <HStack spacing={1}>
            <Text fontSize="xs" color="gray.500" fontFamily="mono" noOfLines={1}>{short}</Text>
            <FiCopy size={11} />
          </HStack>
        )}
      </Box>
    </Tooltip>
  );
};

StripeIdChip.defaultProps = { id: undefined, label: undefined, iconOnly: false };

export default StripeIdChip;
